// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1150":"628349f8","1905":"03241900","3039":"9c2fee3d","7149":"7e123f3c","7948":"58a28d0a"}[chunkId] + ".chunk.css";
};